// Drop-in replacement for firebase/analytics' logEvent that also feeds the
// first-party stream.
//
// The auth, MFA and password surfaces call logEvent directly rather than going
// through a hook, so they bypass the two bridged choke points. Rather than
// rewrite ~60 call sites (and give every future one a choice to get wrong),
// those files swap one import: the signature, arguments and GA4 behaviour are
// identical, and the bridge decides what — if anything — reaches BigQuery.
//
// Call sites keep passing the Firebase analytics instance so the swap is a
// one-line change per file and the diff stays reviewable.

import { logEvent as firebaseLogEvent } from 'firebase/analytics';
import { bridgeGa4Event } from './ga4Bridge';

// Trailing arguments (event params, and the options bag Firebase accepts after
// them) are forwarded as received rather than named and re-passed, so a call
// arrives at Firebase with exactly the arguments the call site wrote — the same
// arity, in the same order — and nothing here has to decide how many there were.
export function logEvent(analyticsInstance, eventName, ...eventArgs) {
  const [params] = eventArgs;
  try {
    if (analyticsInstance) firebaseLogEvent(analyticsInstance, eventName, ...eventArgs);
  } catch (_) {
    // GA4 delivery is best-effort; never disturb an auth flow.
  }
  bridgeGa4Event(eventName, params || {});
}

export default logEvent;
